import { render, staticRenderFns } from "./straightDownPrice.vue?vue&type=template&id=f118f82e&scoped=true&"
import script from "./straightDownPrice.vue?vue&type=script&lang=js&"
export * from "./straightDownPrice.vue?vue&type=script&lang=js&"
import style0 from "./straightDownPrice.vue?vue&type=style&index=0&id=f118f82e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f118f82e",
  null
  
)

export default component.exports